export default [
"Able",
"Acclaimed",
"Accomplished",
"Achiever",
"Adaptable",
"Admirable",
"Adorable",
"Adventurous",
"Affable",
"Affectionate",
"Ageless",
"Agile",
"Agreeable",
"Altruistic",
"Amazing",
"Ambitious",
"Amiable",
"Amusing",
"Angelic",
"Appreciative",
"Articulate",
"Astonishing",
"Astounding",
"Attentive",
"Attractive",
"Authentic",
"Balanced",
"Bashful",
"Beautiful",
"Beauty",
"Believe",
"Beloved",
"Benevolent",
"Big-hearted",
"Billionaire",
"Blessed",
"Bold",
"Bonafide",
"Brainy",
"Brave",
"Breathtaking",
"Bright",
"Brilliant",
"Bubbly",
"Calm",
"Capable",
"Captivating",
"Carefree",
"Careful",
"Caring",
"Centered",
"Champion",
"Charitable",
"Charming",
"Cheerful",
"Classy",
"Clever",
"Compassionate",
"Confident",
"Conscientious",
"Considerate",
"Content",
"Courageous",
"Courteous",
"Creative",
"Credible",
"Cunning",
"Dapper",
"Daring",
"Dashing",
"Debonair",
"Decisive",
"Dedicated",
"Delightful",
"Dependable",
"Deserving",
"Desirable",
"Determined",
"Devoted",
"Dignified",
"Diligent",
"Disciplined",
"Distinguished",
"Divine",
"Down-to-earth",
"Dreamy",
"Drop dead gorgeous",
"Dutiful",
"Dynamo",
"Eager",
"Earnest",
"Educated",
"Efficient",
"Elegant",
"Elite",
"Empathetic",
"Enchanting",
"Endearing",
"Energetic",
"Engaging",
"Engrossed",
"Enthralling",
"Essential",
"Esteem",
"Exceptional",
"Exemplar",
"Exotic",
"Expert",
"Extraordinary",
"Exuberant",
"Fabulous",
"Faithful",
"Famous",
"Fantastic",
"Fascinating",
"Faultless",
"Favorite",
"Fearless",
"Fierce",
"Fine",
"Flawless",
"Forgiving",
"Fortunate",
"Frank",
"Friendly",
"Fun",
"Fabulous",
"Faithful",
"Famous",
"Fantastic",
"Fascinating",
"Faultless",
"Favorite",
"Fearless",
"Fierce",
"Fine",
"Flawless",
"Flexible",
"Forgiving",
"Fortunate",
"Frank",
"Friend",
"Friendly",
"Fun",
"Gay",
"Generous",
"Genial",
"Gentle",
"Genuine",
"Gifted",
"Giving",
"Glamorous",
"Gleeful",
"Glowing",
"Godlike",
"Good-hearted",
"Gorgeous",
"Graceful",
"Gracious",
"Grateful",
"Gregarious",
"Grounded",
"Guru",
"Gutsy",
"Handsome",
"Happy",
"Hardworking",
"Healthy",
"Helpful",
"Hero",
"Heroic",
"Hilarious",
"Honest",
"Honorable",
"Humble",
"Humorous",
"Handsome",
"Happy",
"Hardworking",
"Healthy",
"Helpful",
"Hero",
"Heroic",
"Hilarious",
"Honest",
"Honorable",
"Hottie",
"Humble",
"Humorous",
"Hysterical",
"Icon",
"Idol",
"Illustrious",
"Imaginative",
"Impartial",
"Important",
"Impressive",
"Indispensable",
"Industrious",
"Influential",
"Innocent",
"Innovative",
"Inspirational",
"Inspiring",
"Integrity",
"Intelligent",
"Intuitive",
"Inventive",
"Irresistible",
"Jocose",
"Jocund",
"Joker",
"Jolly",
"Jovial",
"Joy",
"Joyful",
"Jubilant",
"Keen",
"Kickass",
"Kind",
"Kind-hearted",
"Knockout",
"Knowledgeable",
"Laidback",
"Leader",
"Learned",
"Legend",
"Legendary",
"Likable",
"Lovable",
"Lovely",
"Loving",
"Loyal",
"Lucky",
"Manly",
"Master",
"Megastar",
"Mench",
"Merry",
"Mesmerizing",
"Meticulous",
"Mighty",
"Mindful",
"Modest",
"Mogul",
"Motivated",
"Munificence",
"Muse",
"Multimillionaire",
"Natural",
"Neat",
"Neighborly",
"Nice",
"Nifty",
"Nimble",
"Noble",
"Notable",
"Obedient",
"Obliging",
"Observant",
"Omnipotent",
"One of a kind",
"Optimistic",
"Opulent",
"Orderly",
"Outspoken",
"Outstanding",
"Overachiever",
"Pal",
"Passionate",
"Patient",
"Patriot",
"Peaceful",
"Perfect",
"Perfectionist",
"Persistent",
"Personable",
"Phenomenal",
"Philanthropist",
"Philosophical",
"Pioneer",
"Pious",
"Playful",
"Pleasant",
"Polished",
"Polite",
"Popular",
"Posh",
"Positive",
"Powerful",
"Practical",
"Praiseworthy",
"Precious",
"Preeminent",
"Pretty",
"Privileged",
"Pro",
"Proactive",
"Prodigy",
"Prominent",
"Prosperous",
"Prowess",
"Prudent",
"Punctual",
"Qualified",
"Queenly",
"Quick-witted",
"Quiet",
"Rad",
"Radiant",
"Rambunctious",
"Rational",
"Ravishing",
"Real",
"Reassuring",
"Refined",
"Refreshing",
"Regal",
"Relaxed",
"Reliable",
"Reputable",
"Resilient",
"Resourceful",
"Respectable",
"Respected",
"Resplendent",
"Responsible",
"Revered",
"Reverent",
"Rich",
"Righteous",
"Right-minded",
"Rock star",
"Role model",
"Romantic",
"Royal",
"Sagacious",
"Sage",
"Saint",
"Sassy",
"Savior",
"Savvy",
"Scholarly",
"Scrumptious",
"Seasoned",
"Secure",
"Seductive",
"Sedulous",
"Self-assured",
"Selfless",
"Self-made",
"Sensation",
"Sensational",
"Sensible",
"Sensitive",
"Sensual",
"Serene",
"Sexy",
"Sharp",
"Significant",
"Sincere",
"Skilled",
"Smashing",
"Solemn",
"Sophisticated",
"Soulmate",
"Special",
"Specialist",
"Spectacular",
"Spirited",
"Spontaneous",
"Smart",
"Stable",
"Standout",
"Star",
"Statuesque",
"Straightforward",
"Striking",
"Strong",
"Studious",
"Stunner",
"Stunning",
"Stupendous",
"Stylish",
"Suave",
"Successful",
"Superior",
"Superman",
"Superwoman",
"Supportive",
"Survivor",
"Sweet",
"Sweetheart",
"Sympathetic",
"Tactful",
"Talented",
"Tenacious",
"Tender",
"Thankful",
"Thorough",
"Thoughtful",
"Thriving",
"Tidy",
"Tolerant",
"Top-notch",
"Trailblazer",
"Tremendous",
"TRUE",
"Trusting",
"Trustworthy",
"Truthful",
"Ultimate",
"Ultra",
"Unbeatable",
"Unbelievable",
"Unconditional",
"Understanding",
"Unique",
"United",
"Unstoppable",
"Uplifting",
"V.I.P",
"Valor",
"Valuable",
"Valued",
"Vehement",
"Venerate",
"Versed",
"Vibrant",
"Victor",
"Victorious",
"Vigorous",
"Virile",
"Virtuous",
"Visionary",
"Vivacious",
"Voluptuous",
"Warm",
"Warm-hearted",
"Wealthy",
"Well-behaved",
"Well established",
"Well-known",
"Well-liked",
"Well -read",
"Well-rounded",
"Well-spoken",
"Whimsical",
"Willed",
"Willing",
"Willpower",
"Winner",
"Wise",
"Witty",
"Wizard",
"Wonderful",
"Wondrous",
"Wunderkind",
"Xenial",
"X-factor",
"Xyresic",
"Young",
"Young-at -heart",
"Youthful",
"Youthfulness",
"Yummy",
"Yuppie",
"Zaftig",
"Zappy",
"Zealous",
"Zest",
"Zestful",
"Zinger"
]